<h1>Scheduled Services</h1>

<div class="sectionContainer paddedContent containerMargins">
  Recurring Billing:<br />
  <input
    type="button"
    class="button_primary button_var_1"
    value="Run Cron"
    (click)="runRecurringBillingCron()"
  />
</div>

<div class="sectionContainer paddedContent containerMargins">
  Fiserv Data Import:<br />
  <input
    type="button"
    class="button_primary button_var_1"
    value="Run Cron"
    (click)="runFiservDataImportCron()"
  />
</div>
